import React, { useContext, useEffect, useState } from "react";
import { Modal, Progress, Upload } from "antd";
import ImgCrop from "antd-img-crop";
import { PictureOutlined } from "@ant-design/icons";
import FileKeysContext from "../../../../../context/fileKeysContext";
import axios from "axios";
import UploadingProcessContext from "../../../../../context/uploadingProcessContext";
import { toast } from "react-toastify";

function AvatarModal() {
  const [uploadProgress, setUploadProgress] = useState(0);
  const [fileList, setFileList] = useState([]);
  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewImage, setPreviewImage] = useState("");
  const [previewTitle, setPreviewTitle] = useState("");

  const { expertAvatarKeyAction } = useContext(FileKeysContext);
  const { uploadingAction } = useContext(UploadingProcessContext);

  const handlePreview = async (file) => {
    if (!file.url && !file.preview) {
      file.preview = await getBase64(file);
    }

    setPreviewImage(file.url || file.preview);
    setPreviewOpen(true);
    setPreviewTitle(file.name);
  };

  const getBase64 = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file.originFileObj);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });

  const onRemove = (file) => {
    return new Promise((resolve, reject) => {
      setFileList(fileList.filter((f) => f?.uid !== file?.uid));
      expertAvatarKeyAction("");
      resolve(true);
    });
  };

  const customRequest = async (options) => {
    uploadingAction(true)
    const { file, onSuccess, onError, onProgress } = options;
    const isLt5M = (file.size / (1024 * 1024)) * 10 <= 5;
    if (!isLt5M) {
      onError(toast.error("حجم فایل باید کمتر از   5 مگابایت باشد"));
      return;
    }
    try {
      // send file name to get upload info
      const response = await axios.post(
        process.env.REACT_APP_EXPERT_BASE_URL + "/files/s3-upload-file",
        { filename: file?.name }
      );
      // destructure upload info
      const { url, fields } = response?.data?.result?.data;
      const { key } = fields; // key is in fields
      // create formdata
      let formData = new FormData();
      Object.entries(fields).map(([key, value]) => {
        return formData.append(key, value);
      });
      formData.append("file", file);

      // progress tracking config
      const config = {
        onUploadProgress: (progressEvent) => {
          const percentCompleted = Math.round(
            (progressEvent.loaded * 100) / progressEvent.total
          );
          setUploadProgress(percentCompleted); // Update the upload progress
          onProgress({ percent: percentCompleted }, file); // Notify Ant Design of the progress
        },
      };

      // upload formdata to Arvan cloud
      const arvanResponse = await axios.post(url, formData, config);
      // set context data
      expertAvatarKeyAction(key);
      // add originFileObj and key to file
      file.originFileObj = file;
      file.key = key;
      setFileList([...fileList, file]);

      uploadingAction(false)
      // call onSuccess
      onSuccess(arvanResponse?.data);
    } catch (error) {
      uploadingAction(false)
      onError(error);
    }
  };

  return (
    <form className="flex flex-row font-body whitespace-nowrap p-10 justify-between max-lg:p-0 max-lg:gap-2 items-center">
      <p>لطفا تصویر پروفایل خود را آپلود کنید.</p>

      <div className="flex flex-col font-body">
        <ImgCrop
          aspect={1}
          showGrid={true}
          modalCancel="لغو"
          modalOk="تایید"
          rotationSlider={true}
          showReset
          resetText="لغو تغییرات"
        >
          <Upload
            customRequest={customRequest}
            listType="picture-card"
            fileList={fileList}
            onPreview={handlePreview}
            onRemove={onRemove}
            accept=".png, .jpg, .jpeg"
            maxCount={1}
          >
            {fileList.length >= 1 ? null : (
              <PictureOutlined className="text-7xl text-[#7F7F7F] " />
            )}
          </Upload>
        </ImgCrop>
        {uploadProgress > 0 && uploadProgress < 100 && (
          <Progress className="z-50" percent={uploadProgress} status="active" />
        )}
        <Modal
          open={previewOpen}
          title={previewTitle}
          footer={null}
          onCancel={() => setPreviewOpen(false)}
        >
          <img alt="example" style={{ width: "100%" }} src={previewImage} />
        </Modal>
      </div>
    </form>
  );
}

export default AvatarModal;
